// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"83":"14b41e18","501":"d18b8cc2"}[chunkId] + ".css";
};